import {FileStorageFactory} from 'web-common/services/files/FileStorageFactory'
import {AWSFileStorage} from 'web-common/services/files/AwsAPI'

const FileStorage = new FileStorageFactory(AWSFileStorage.shared())
export default FileStorage
